import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Location } from '@cpd-app/core-module/models';

import { AppState } from '../index';
import * as HotSpotsActions from './hot-spots.actions';
import {
  locations,
  occupationDemandbyArea,
  occupationDemandInUserHomeArea,
  occupationHotSpots
} from './hot-spots.selectors';

@Injectable({
  providedIn: 'root'
})
export class HotSpotsFacade {
  constructor(private store: Store<AppState>) {}

  public locations$ = this.store.select(locations);
  public occupationHotSpots$ = this.store.select(occupationHotSpots);
  public occupationDemandInUserHomeArea$ = this.store.select(
    occupationDemandInUserHomeArea
  );
  public occupationDemandbyArea$ = this.store.select(occupationDemandbyArea);

  public deletePreferredLocation(locationModel: Location): void {
    this.store.dispatch(
      HotSpotsActions.deletePreferredLocation({ locationModel })
    );
  }

  public searchLocations(searchTerm: string): void {
    this.store.dispatch(HotSpotsActions.searchLocations({ searchTerm }));
  }

  public putPreferredLocation(locationModel: Location): void {
    this.store.dispatch(
      HotSpotsActions.putPreferredLocation({ locationModel })
    );
  }

  public getHotspots(): void {
    this.store.dispatch(HotSpotsActions.getHotspots());
  }
}
